const styles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    main: {},
    spacer: {
        padding: theme.spacing(1.5),
    },
    tableWrapper: {
        marginTop: theme.spacing(2),
    },
    tableHeadCell: {
        fontWeight: 600,
    },
    selectControl: {
        minWidth: 160,
    },
    statusChip: {
        marginLeft: theme.spacing(1),
    },
});

export default styles;
